import { createFileRoute, notFound } from "@tanstack/react-router";
import { PortalNotFound } from "@/components/PortalNotFound";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/client/$")({
  head: () => pageHead('Client Page Not Found', 'This AKIVA client portal page does not exist.', '/client', true),
  beforeLoad: () => { throw notFound(); },
  notFoundComponent: PortalNotFound,
});
